const { REACT_APP_CONTEXT_PATH } = process.env;

export const getTicketInfoApi = (ticketId) => ({
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  apiUrl: `${REACT_APP_CONTEXT_PATH}/ticket/${ticketId}/info`,
});
